import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Paper,
  Button,
} from "@mui/material";
import MuiHeader from "../../components/MuiHeader";
import moment from "moment";
import apiPrakasak from "../../api/apiPrakasak";

const UserLogs = () => {
  const dispatch = useDispatch();

  const monthArr = [
    { value: 0, label: "None" },
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 2 }, (_, index) => currentYear - index);

  const currentMonth = moment().month() + 1;
  const currentMonthLabel = monthArr.find(
    (item) => item.value === currentMonth
  )?.label;

  console.log("currentMonth--->", currentMonth, currentYear);

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [userLogs, setUserLogs] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleMonthChange = async (e) => {
    if (e.target.value > currentMonth && selectedYear === currentYear) {
      alert("You can't select a month greater than the current month!");
    } else {
      setSelectedMonth(e.target.value ? e.target.value : "");
    }
  };

  const handleFilter = async () => {
    if (selectedYear && !selectedMonth) {
      alert("Select Month");
    } else if (selectedYear && selectedMonth) {
      const response = await apiPrakasak.get(
        `getAutomationLogs/${selectedMonth}/${selectedYear}`
      );
      console.log("response---->", response.data, response.status);

      if (response.status === 200) {
        setUserLogs(response.data);
      } else if (response.status === 204) {
        alert("No logs Found");
      } else {
        console.log("check=--------");
      }
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <MuiHeader header="User Logs" />

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <FormControl
          sx={{ width: "100%" }}
          style={{ width: "130px" }}
          size="small"
        >
          <InputLabel id="year-select-label">Year</InputLabel>
          <Select
            labelId="year-select-label"
            id="year-select"
            value={selectedYear}
            onChange={handleYearChange}
            label="Year"
          >
            {years?.length > 0 &&
              years?.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl
          sx={{ m: 1 }}
          size="small"
          style={{ width: "130px", marginTop: -1 }}
        >
          <InputLabel id="usertype-label">Month</InputLabel>
          <Select
            labelId="usertype-label"
            id="usertype-select"
            value={selectedMonth}
            onChange={handleMonthChange}
            label="Month"
          >
            <MenuItem value={null}>None</MenuItem>
            {monthArr.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          onClick={handleFilter}
          variant="contained"
          style={{
            backgroundColor: "blue",
            width: "150px",
            height: "40px",
            // fontSize: "14px",
            // padding: "8px 16px",
          }}
        >
          Filter
        </Button>
      </div>

      <div
        style={{
          width: "100%",
          // margin: "20px",
          // alignSelf: "center",
        }}
      >
        {/* {studentData && ( */}
        <div
          style={{
            height: "700px",
            overflowY: "auto",
          }}
        >
          {userLogs?.length > 0 ? (
            <table
              style={{
                minWidth: "800px",
                width: "100%",
                display: "table",
              }}
            >
              <thead
                style={{
                  backgroundColor: "#f2f2f2",
                  position: "sticky",
                  top: "0",
                }}
              >
                <tr>
                  <th
                    key="no"
                    style={{
                      border: "1px solid #dddddd",
                      padding: "10px",
                    }}
                  >
                    Sl. no
                  </th>

                  <th>Initiated By</th>

                  <th>Task Description</th>

                  <th>Task Status</th>

                  <th>Actions</th>

                  <th>Failed Reason</th>

                  <th>Started At</th>

                  <th>Finished At</th>
                </tr>
              </thead>

              <tbody>
                {userLogs &&
                  userLogs?.length > 0 &&
                  userLogs
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                        }}
                      >
                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {row.initiatedBy}
                        </td>
                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {row.taskDescription}
                        </td>
                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {row.taskStatus}
                        </td>

                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {row.taskStatus}
                        </td>
                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {row.failReason}
                        </td>
                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {moment(row.startedAt).format("DD-MM-YY")}
                        </td>

                        <td
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          {moment(row.finishedAt).format("DD-MM-YY")}
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          ) : (
            <span style={{ fontWeight: "bold" }}>No Record Found</span>
          )}
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default UserLogs;
